// prettier-ignore
export const GameDataActionTypes = {
  SET_STATE: 'SET_STATE',
  UPDATE_STATE: 'UPDATE_STATE',
  SET_DATA_READY: 'SET_DATA_READY',
  SET_IS_THEATRE_MODE: 'SET_IS_THEATRE_MODE'
};
